module.exports = __webpack_public_path__ + "media/7.aa08cd78.mp3";